export default class EntryRequirements {
  constructor(el) {
    this.el = el;
    this.entry = './src/programmes/entryrequirements.js';
    this.endpoint = '/feeds/apex/ersProgrammeCountry';
    this.countryendpoint = '/feeds/countrypicker/?countries=true';
    this.programme_id = programme_id;
    this.default = defaultEntryRequirements;
    this.defaultSendToSchoolSubjects = defaultSendToSchoolSubjects;
    this.defaultSendToSchoolGrades = defaultSendToSchoolGrades;
    this.init();
  }

  init() {


    // Check for preferences link, if no link add it
    if (!this.preferencesLink) {
      this.insertPreferencesLink();
    }

    // Check for country selector, if no selector add it
    if (!this.countrySelector) {
      this.insertCountrySelector();
    }

    // Check for title, if no title add it
    if (!this.title) {
      this.insertTitle();
    }

    // Add click event to preferences link
    this.preferencesLink.addEventListener(
      'click',
      this.preferencesLinkClickHandler
    );

    // Add listener for country selector changes
    this.countrySelector.addEventListener('change', (e) => {
      this.countrySelectorChangeHandler(e);
    });

    // Check for country cookie, if no cookie do nothing
    if (!this.country) {
      return;
    } else {
      this.getCountryDetails().then((country) => {
        this.isUK(country)
          ? this.getEntryRequirements(true)
          : this.getEntryRequirements();
      });
    }
  }

  insertPreferencesLink() {
    // Insert link with text 'Change your preferences' before this.el
    this.preferencesLink = document.createElement('a');
    this.preferencesLink.href = '#';
    this.preferencesLink.textContent = 'Change your preferences';
    this.preferencesLink.classList.add('hide');
    this.el.parentNode.insertBefore(this.preferencesLink, this.el);
  }

  insertCountrySelector() {
    // Insert country selector before this.el
    this.countrySelector = document.createElement('select');
    this.countrySelector.id = 'countrySelector';
    this.countrySelector.classList.add('entry-country-select');
    //add aria label
    this.countrySelector.setAttribute(
      'aria-label',
      'Select your country/region'
    );
    this.countrySelector.innerHTML = `<option value="">Select your country/region</option>`;
    this.el.parentNode.insertBefore(this.countrySelector, this.el);

    function getCountries() {
      return import(/* webpackChunkName: "gu-countries" */ '../utils/countries')
        .then(({ default: Countries }) => {
          return Countries;
        })
        .catch((error) => 'An error occurred while loading the component');
    }

    getCountries().then((Countries) => {
      new Countries('entry-country-select');
    });
  }

  insertTitle(isDefault) {
    // Insert title before this.el
    //if entry title already populated remove it
    if (document.getElementById('entry-title')) {
      document.getElementById('entry-title').remove();
    }
    this.getCountryDetails().then((country) => {
      const textcontent = country.title
        ? isDefault
          ? `Showing standard entry requirements`
          : `Showing requirements for ${country.title}`
        : `Showing standard entry requirements`;
      if (document.getElementById('entry-title')) {
        document.getElementById('entry-title').textContent = textcontent;
      } else {
        this.title = document.createElement('span');
        this.title.id = 'entry-title';
        this.title.textContent = textcontent;
        this.el.parentNode.insertBefore(this.title, this.el);
      }
    });
  }

  preferencesLinkClickHandler() {
    // Placeholder - alert clicked
    alert('Clicked');
  }

  countrySelectorChangeHandler(e) {
    // Get the data-id attribute of the selected option
    const selectedOption = e.target.options[e.target.selectedIndex];
    const dataId = selectedOption.getAttribute('data-id');

    // Set the gu_ct cookie to the data-id value
    this.setCountryCookie(dataId);

    // Set this.country to the data-id value
    this.country = dataId ? dataId : null;
    if(!this.country) {
      this.el.innerHTML = `<p class="entry-requirements-placeholder">Please select your country or region to see entry requirements.</p>`;
      this.title.innerHTML = `<span>Showing standard entry requirements</span>`;
      this.getEntryRequirements(true);
      return;
    }

    // Fetch entry requirements for the selected country
    this.getCountryDetails().then((country) => {
      this.isUK(country)
        ? this.getEntryRequirements(true)
        : this.getEntryRequirements();
    });
  }

  getEntryRequirements(standard = false) {
    // Fetch entry requirements from endpoint and replace this.el innerHTML with response
    //set inner html to centre aligned loading gif
    this.el.innerHTML = `<div style="text-align: center;">
        <svg xmlns="http://www.w3.org/2000/svg" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-ellipsis" style="background: none; text-align: center;"><circle cx="84" cy="50" r="0" fill="#5b4d94"><animate attributeName="r" values="10;0;0;0;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="0s"></animate><animate attributeName="cx" values="84;84;84;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="0s"></animate></circle><circle cx="16" cy="50" r="9.6148" fill="#951272"><animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="-1.85s"></animate><animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="-1.85s"></animate></circle><circle cx="84" cy="50" r="0.385197" fill="#0274af"><animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="-0.925s"></animate><animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="-0.925s"></animate></circle><circle cx="82.6903" cy="50" r="10" fill="#011451"><animate attributeName="r" values="0;10;10;10;0" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="0s"></animate><animate attributeName="cx" values="16;16;50;84;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="0s"></animate></circle><circle cx="48.6903" cy="50" r="10" fill="#5b4d94"><animate attributeName="r" values="0;0;10;10;10" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="0s"></animate><animate attributeName="cx" values="16;16;16;50;84" keyTimes="0;0.25;0.5;0.75;1" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" calcMode="spline" dur="3.7s" repeatCount="indefinite" begin="0s"></animate></circle></svg>
        </div>`;
    this.title
      ? (this.title.innerHTML = `<span>Loading entry requirements...</span>`)
      : null;
    setTimeout(() => {
      if (!standard) {
        fetch(`${this.endpoint}/${this.country}/${this.programme_id}`)
          .then((response) => response.text())
          .then((data) => {
            const countryDetails = JSON.parse(data);
            const reqtext = countryDetails.country_entry_requirements_text;
            const schooltext = countryDetails.country_school_requirements_text;
            const progsubjecttext =
              countryDetails.prog_send_to_school_subjects !== null
                ? countryDetails.prog_send_to_school_subjects
                : this.defaultSendToSchoolSubjects;
            const proggradestext =
              countryDetails.prog_send_to_school_grades !== null
                ? countryDetails.prog_send_to_school_grades
                : this.defaultSendToSchoolGrades;
            this.el.innerHTML =
              reqtext !== null
                ? `
                        <p>${reqtext}</p>
                            ${progsubjecttext !== null ? `<p class="er-prog-subject-text">${progsubjecttext}</p>` : ``}
                            ${schooltext !== null ? `<p class="er-country-school-text">${schooltext}</p>` : ``}
                        `
                : `<p>Unfortunately we do not have entry requirements for the country you selected: please see below for the entry requirements for the United Kingdom:</p>
                        <p>${this.default}</p>
                        ${progsubjecttext !== null ? `<p class="er-prog-subject-text">${progsubjecttext}</p>` : ``}
                        ${proggradestext !== null ? `<p class="er-prog-grades-text">${proggradestext}</p>` : ``}`;
            standard = typeof reqtext !== 'string';
            this.insertTitle(standard);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      } else {
        this.el.innerHTML = `
            <p>${this.default}</p>
            ${this.defaultSendToSchoolSubjects !== null ? `<p class="er-prog-subject-text">${this.defaultSendToSchoolSubjects}</p>` : ``}
            ${this.defaultSendToSchoolGrades !== null ? `<p class="er-prog-grades-text">${this.defaultSendToSchoolGrades}</p>` : ``}`;
        this.insertTitle(true);
      }
    }, 1000);
  }

  setCountryCookie(val) {
    // Set cookie 'gu_ct' with value val
    // document.cookie = `gu_ct=${val}`;
  }

  getCountryCookie() {
    // Get value of cookie 'gu_ct' - if cookie doesn't exist return false otherwise return value of cookie
    if (
      document.cookie
        .split(';')
        .some((item) => item.trim().startsWith('gu_ct='))
    ) {
      return document.cookie
        .split(';')
        .find((row) => row.trim().startsWith('gu_ct='))
        .split('=')[1];
    }
    return false;
  }

  isUK(country) {
    try {
      return country.isUk === true;
    } catch (error) {
      console.error('Error in isUK:', error);
      return false; // Return false in case of an error
    }
  }

  async getCountryDetails() {
    try {
      if (!this.countries) {
        const response = await fetch(this.countryendpoint);
        const data = await response.json();
        this.countries = data;
      }

      // Iterate through data and check if the country is UK
      for (const item of this.countries) {
        if (item.id == this.country) {
          return item;
        }
      }

      // If the country is not found, return false
      return false;
    } catch (error) {
      console.error('Error in get country details:', error);
      return false; // Return false in case of an error
    }
  }
}
